(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rr-customer-stories"] && !Shopify.designMode) return;
  try {
    
function initRRTestimonials(){document.querySelectorAll('.rr-testimonials-film').forEach(film=>{if(film.dataset.ready)return;film.dataset.ready='true';const video=film.querySelector('video');const button=film.querySelector('button');button.addEventListener('click',()=>video.play().catch(()=>{video.controls=true}));video.addEventListener('play',()=>{button.hidden=true});video.addEventListener('pause',()=>{button.hidden=false});video.addEventListener('ended',()=>{button.hidden=false})})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRRTestimonials);else initRRTestimonials();document.addEventListener('shopify:section:load',initRRTestimonials);

  } catch(e) { console.error(e); }
})();
})();
